import Harry from './players/110254-Harry Messenger.json';
import Sharkey from './players/113299-Michael Sharkey.json';
import Steve from './players/127441-Steve Edwards.json';
import Rob from './players/146166-Robert Nicoll.json';
import Danny from './players/150264-Daniel Greenhalgh.json';
import Matt from './players/162745-Matt Lee.json';
import Bob from './players/180314-Bob O\'Leary.json';
import Luke from './players/182987-Luke Dodd Adkins.json';
import Max from './players/194115-Maximilian Berkmann.json';
import Pete from './players/203514-Peter Foden.json';

const MDGT = [Harry, Sharkey, Steve, Rob, Danny, Matt, Bob, Luke, Max, Pete];

export default MDGT;